import { fromJS, Map } from 'immutable'
import { CLEAR_APOLLO_AUDIT_LOG, GET_APOLLO_AUDIT_LOG, GET_APOLLO_AUDIT_LOG_DETAILS } from '../actions/actionTypes'
import { ApolloAuditLog, ApolloAuditLogDetails, ApolloAuditLogDetailsProps } from '../types/coreEntitiesTypes'
import { ImmutableMap } from '../types/immutableTypes'

type ApolloAuditLogActionType = GetApolloAuditLog | GetApolloAuditLogDetails | ClearApolloAuditLog

interface GetApolloAuditLog {
  type: typeof GET_APOLLO_AUDIT_LOG.SUCCESS
  params: { date: string }
  body: Map<number, ImmutableMap<ApolloAuditLog>>
}

interface GetApolloAuditLogDetails {
  type: typeof GET_APOLLO_AUDIT_LOG_DETAILS.SUCCESS
  params: { id: number }
  body: ApolloAuditLogDetailsProps
}

interface ClearApolloAuditLog {
  type: typeof CLEAR_APOLLO_AUDIT_LOG
}

const initialState = Map({
  auditLogs: Map(),
  auditLogDetails: Map<number, ApolloAuditLogDetails>()
})

export default (state = initialState, action: ApolloAuditLogActionType) => {
  switch (action.type) {
    case CLEAR_APOLLO_AUDIT_LOG:
      return initialState
    case GET_APOLLO_AUDIT_LOG.SUCCESS: {
      const log = action as GetApolloAuditLog
      return state.withMutations((mState) => {
        return fromJS(log.body).map((v: ImmutableMap<ApolloAuditLog>, k: number) => {
          return mState.setIn(['auditLogs', log.params['date'], k.toString()], v)
        })
      })
    }
    case GET_APOLLO_AUDIT_LOG_DETAILS.SUCCESS: {
      const details = action as GetApolloAuditLogDetails
      return state.withMutations((mState) => {
        return mState.setIn(['auditLogDetails', details.params.id], fromJS(details.body))
      })
    }
    default:
      return state
  }
}
